import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from 'react';
import { Container } from '../../../../components/NPS/components/Rating/components/Container.js';
import { RatingItem } from '../../../../components/NPS/components/Rating/components/RatingItem/index.js';
export const Rating = React.memo(({
  min,
  max,
  selected,
  onChange
}) => _jsx(Container, {
  children: [...Array(max - min + 1).keys()].map(i => _jsx(RatingItem, {
    id: `rating-${i + min}`,
    label: `${i + min}`,
    value: `${i + min}`,
    checked: selected === i + min,
    onChange: onChange
  }, `rating-${i + min}`))
}));